import React from 'react';
import MTCLandingPage from '../home' 

const Layout = () => {
    return (
        <>
            <MTCLandingPage />
            
        </>
    )
}

export default Layout
